import { Link } from "react-router-dom";
import logoDark from "@/assets/logo-horizontal.png";
import logoLight from "@/assets/logo-horizontal-light.png";

// Official horizontal logo. `light` swaps to the white-text version for navy backgrounds.
export default function Logo({ light = false, className = "" }) {
  return (
    <Link
      to="/"
      className={`inline-flex items-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-citrine focus-visible:ring-offset-4 ${className}`}
      data-testid="logo-home-link"
      aria-label="Rao Investment Solutions — home"
    >
      <img
        src={light ? logoLight : logoDark}
        alt="Rao Investment Solutions"
        width="278"
        height="106"
        className="h-12 md:h-14 w-auto select-none"
        draggable="false"
      />
    </Link>
  );
}
